import React, { useMemo } from 'react'
import Chip from 'redesign/components/atoms/Chip'
import { CHIP_SIZE } from 'redesign/components/atoms/Chip/constants'
import { ScrollableContainer, StackedContainer } from './styles'
import type { RemovableChipGroupProps } from './types'

const RemovableChipGroup: React.FC<RemovableChipGroupProps> = ({
  options,
  onDelete,
  onClick,
  size = CHIP_SIZE.medium,
  isStackedChips,
}) => {
  const optionChips = useMemo(
    () =>
      options.map(({ label, value }) => (
        <Chip size={size} key={value} label={label} onDelete={() => onDelete(value)} selected onClick={onClick} />
      )),
    [onClick, onDelete, options, size],
  )

  const Container = isStackedChips ? StackedContainer : ScrollableContainer

  return <Container>{optionChips}</Container>
}

export default RemovableChipGroup
